module.exports = __webpack_public_path__ + "static/media/bankseta_headerlogo.77e20447.jpg";